import React from 'react'
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
} from '@mui/material'
import { CsvValidationError } from '../../ShedManagementTypes'

interface CsvValidationErrorTableProps {
  errors: CsvValidationError[]
}

const CsvValidationErrorTable: React.FC<CsvValidationErrorTableProps> = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
      <Typography variant='subtitle1' sx={{ p: 1.5, backgroundColor: 'error.light', color: 'white' }}>
        Erros de Validação no Arquivo CSV
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>Linha</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Erro</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {errors.map((error, index) => (
            <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
              <TableCell>{error.linha}</TableCell>
              <TableCell>{error.erro}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CsvValidationErrorTable
